import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import LabelInput from '@components/LabelInput/LabelInput';

class EvidenceOfInsuranceDateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ref_number: props.entity.ref_number,
      focused: false,
      error: false
    };
  }

  submitHandler = e => {
    e.preventDefault();

    this.props.loader(true);

    this.props.saveEntity(
      {
        ref_number: this.state.ref_number
      },
      () => {
        this.props.loader(false);
        this.props.toggle();
      }
    );

    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {this.props.header}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              <Row>
                <Col xs={12}>
                  <LabelInput
                    name={'Reference Number'}
                    type={'text'}
                    value={this.state.ref_number}
                    onChange={event =>
                      this.setState({
                        ref_number: event.target.value
                      })
                    }
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                {this.props.edit !== undefined ? 'Save' : 'Create'}
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default EvidenceOfInsuranceDateModal;
